import ThemedSvgIcon from './ThemedSvgIcon';

const PersonnelIcon = (props) => (
    <ThemedSvgIcon {...props}>
        {(fill) => (
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.5 7.5C7.5 8.82608 8.02678 10.0979 8.96447 11.0355C9.90215 11.9732 11.1739 12.5 12.5 12.5C13.8261 12.5 15.0979 11.9732 16.0355 11.0355C16.9732 10.0979 17.5 8.82608 17.5 7.5C17.5 6.17392 16.9732 4.90215 16.0355 3.96447C15.0979 3.02678 13.8261 2.5 12.5 2.5C11.1739 2.5 9.90215 3.02678 8.96447 3.96447C8.02678 4.90215 7.5 6.17392 7.5 7.5ZM11.1914 15.3203L11.918 16.5312L10.6172 21.3711L9.21094 15.6328C9.13281 15.3164 8.82812 15.1094 8.51172 15.1914C5.77734 15.875 3.75 18.3516 3.75 21.3008C3.75 21.9648 4.28906 22.5 4.94922 22.5H20.0508C20.7148 22.5 21.25 21.9609 21.25 21.3008C21.25 18.3516 19.2227 15.875 16.4883 15.1914C16.1719 15.1133 15.8672 15.3203 15.7891 15.6328L14.3828 21.3711L13.082 16.5312L13.8086 15.3203C14.0586 14.9023 13.7578 14.375 13.2734 14.375H11.7305C11.2461 14.375 10.9453 14.9062 11.1953 15.3203H11.1914Z"
                    fill={fill}
                />
            </svg>
        )}
    </ThemedSvgIcon>
);

export default PersonnelIcon;
